import type { SliceStateFromReducer } from 'shared/types';

import type { creditTimerSlice } from 'entities/scenario/model/timer/creditTimer.slice';

export type TCreditTimerState = SliceStateFromReducer<typeof creditTimerSlice>;

export const getRemainingSeconds = (state: TCreditTimerState) => state.creditTimer.remaining;
